import { useMemo } from "react";

export const useDependentOptions = (key: string, optionsMap: Record<string, Record<string, { value: string; label: string }>>) => {
  const dependedOptions = useMemo(() => {
    return optionsMap[key] ?? {};
  }, [key, optionsMap]);

  return {
    key,
    optionsArray: Object.values(dependedOptions),
    optionsMap: dependedOptions,
  };
};
